import request from '@/utils/request';
// OrderPolling/eventList
export const getEventList = (params: any) =>
  request({
    url: 'OrderPolling/eventList',
    method: 'GET',
    params
  });
  // 巡检任务列表
// 获取巡检计划列表
export const getPlanList = (params: any) =>
  request({
    url: 'OrderPolling/planList',
    method: 'GET',
    params
  });
  // 巡检任务列表
export const getJobList = (params: any) =>
  request({
    url: 'OrderPolling/jobList',
    method: 'GET',
    params
  });
  //  删除任务
export const delJob = (data: any) =>
  request({
    url: 'OrderPolling/job',
    method: 'DELETE',
    data
  });
export const editorJob = (data: any) =>
  request({
    url: 'OrderPolling/job',
    method: 'PUT',
    data
  });
  // 删除计划
export const delPlan = (data: any) =>
  request({
    url: 'OrderPolling/plan',
    method: 'DELETE',
    data
  });
// 添加计划
export const addPlan = (data: any) =>
  request({
    url: 'OrderPolling/plan',
    method: 'post',
    data
  });
  // 编辑计划
export const editorPlan = (data: any) =>
  request({
    url: 'OrderPolling/plan',
    method: 'put',
    data
  });
// 延长计划
export const extendPlan = (data: any) =>
request({
  url: 'OrderPolling/extendPlan',
  method: 'put',
  data
});

export const editProjectEventCheck = (data: any) =>
request({
  url: 'OrderPolling/editProjectEventCheck',
  method: 'put',
  data
});

export const syncEventCheck = (data: any) =>
  request({
    url: 'OrderPolling/syncEventCheck',
    method: 'put',
    data
  });

  
  // 检查项列表
export const getCheckList = (params: any) =>
  request({
    url: 'OrderPolling/checkList',
    method: 'GET',
    params
  });
  // OrderPolling/polling
export const addPollingOnce = (data: any) =>
  request({
    url: 'OrderPolling/polling',
    method: 'post',
    data
  });
export const addEvent = (data: any) =>
  request({
    url: 'OrderPolling/event',
    method: 'post',
    data
  });
export const editEvent = (data: any) =>
  request({
    url: 'OrderPolling/event',
    method: 'PUT',
    data
  });
export const batchDeleteEvent = (data: any) =>
  request({
    url: 'OrderPolling/batchDeleteEvent',
    method: 'DELETE',
    data
  });
export const delEvent = (data: any) =>
  request({
    url: 'OrderPolling/event',
    method: 'DELETE',
    data
  });
  // 设置检查项
export const setEventCheck = (data: any) =>
  request({
    url: 'OrderPolling/eventCheck',
    method: 'PUT',
    data
  });
// 删除检查项
export const delEventCheck = (data: any) =>
  request({
    url: 'OrderPolling/eventCheck',
    method: 'DELETE',
    data
  });
  // 删除检查项
export const delCheck = (data: any) =>
  request({
    url: 'OrderPolling/check',
    method: 'DELETE',
    data
  });
// 添加检查项
export const addEventCheck = (data: any) =>
  request({
    url: 'OrderPolling/check',
    method: 'post',
    data
  });
// 编辑检查项
export const editorEventCheck = (data: any) =>
  request({
    url: 'OrderPolling/check',
    method: 'PUT',
    data
  });
  // 导入
export const importEvent = (data: any) =>
  request({
    url: 'OrderPolling/importEvent',
    method: 'post',
    data
  });
export const getJobCount = (params: any) =>
  request({
    url: 'OrderPolling/jobCount',
    method: 'GET',
    params
  });
